import {Box, Clickable, HStack, Icon, Text} from 'platform/foundation';
import styled from 'styled-components';

import {suffixTestId, TestIdProps, useBoolean, useQueryState} from 'shared/web';

import {languageDialogItems} from '../../../../../constants/languageDialogItems';
import {queryParams} from '../../../../../constants/queryParams';
import {FALLBACK_LANGUAGE} from '../../../../../i18n/fallbackLanguage';
import i18n from '../../../../../i18n/i18n';
import {AppLanguage} from '../../../../../types/AppLanguage';
import {LanguageDialogModal} from './LanguageDialogModal';

export function LanguageSwitcher(props: TestIdProps) {
  const [isVisible, open, close] = useBoolean(false);
  const [, setLanguage] = useQueryState(queryParams.LANG);

  const onChangeLanguage = (lang: AppLanguage) => {
    i18n
      .changeLanguage(lang)
      .then(() => {
        setLanguage(lang);
      })
      .catch(() => {
        throw new Error('Failed to set the application language');
      });
  };

  const flagIcon =
    languageDialogItems[(i18n?.resolvedLanguage ?? FALLBACK_LANGUAGE) as AppLanguage].icon;

  return (
    <StyledWrapper data-testid={suffixTestId('wrapper', props)}>
      <Clickable height="100%" onClick={open} data-testid={suffixTestId('button', props)}>
        <Box height={8} paddingHorizontal={2}>
          <HStack height="100%" align="center" justify="center" spacing={2}>
            <Icon value={flagIcon} size={7} data-testid={suffixTestId('flag', props)} />
            <Text color="white" size="small" data-testid={suffixTestId('languageName', props)}>
              {i18n?.resolvedLanguage ?? FALLBACK_LANGUAGE}
            </Text>
          </HStack>
        </Box>
      </Clickable>
      <LanguageDialogModal
        isOpen={isVisible}
        onChoseLanguage={onChangeLanguage}
        onClose={close}
        data-testid={suffixTestId('modal', props)}
      />
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  border-radius: ${({theme}) => theme.radii.small};

  &:hover {
    background-color: ${({theme}) => theme.colors.general.hover};
  }
`;
